import XlsxApi from "../api/XlsxApi";

export const getXlsxBase64 = (csvString: string[][]) => {
  return XlsxApi.getXlsxBase64(csvString);
};
